import Head from "next/head";
import { END } from "redux-saga";
import { useSelector } from "react-redux";

// import About from "../src/components/pages/about/About";
import About from "../src/components/pages/about/NewAbout";
import Routes from "../src/routes/Routes";

import { wrapper } from "../src/config/Store";
import { getAllCMS } from "../src/redux/cms/CMSActions";
import constants from "../src/utils/Constants";

const { CMS_TYPES, CMS_PAGES } = constants;

const nextAboutus = () => {
  const mPageDetails = useSelector(({ cms }) => {
    const boardKey = JSON.stringify({
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.ABOUT_US,
    });

    const boards = cms.boards;
    const mPageDetailsId = boards[boardKey]?.list?.[0];

    return cms.cmsMap[mPageDetailsId] || {};
  });

  return (
    <>
      <Head>
        <title>{mPageDetails?.name}</title>
        <meta name="description" content={mPageDetails?.description} />
        <meta itemProp="name" content="" />
        <meta itemProp="description" content="" />
        <meta itemProp="image" content="" />
        <link rel="canonical" href={`${Routes?.domain}${Routes?.about_us}`} />
      </Head>

      <About />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (context) => {
    const cmsState = store.getState().cms;

    const pageMetaParams = {
      type: CMS_TYPES.PAGE_META,
      page_name: CMS_PAGES.ABOUT_US,
    };
    const pageMetaBoard = cmsState.boards[JSON.stringify(pageMetaParams)];
    if (!pageMetaBoard) {
      store.dispatch(getAllCMS(pageMetaParams));
    }

    const params = { type: "AboutUs" };
    const homeSliderBoard = cmsState.boards[JSON.stringify(params)];
    if (!homeSliderBoard) {
      store.dispatch(getAllCMS(params));
    }

    if (!pageMetaBoard || !homeSliderBoard) {
      store.dispatch(END);
    }

    await store.sagaTask.toPromise();
  }
);

export default nextAboutus;
